import { ChangeDetectionStrategy, Component, input, InputSignal } from '@angular/core'
import { WidgetInterface } from '@modules/widgets-module/interfaces/widget.interface'
import { PortfolioSettingsInterface } from '@shared/components/trading/portfolio/core/interfaces/portfolio-settings.interface'
import { PortfolioComponent } from '@shared/components/trading/portfolio/portfolio.component'

@Component({
	selector: 'app-portfolio-widget',
	templateUrl: './portfolio-widget.component.html',
	styleUrl: './portfolio-widget.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [PortfolioComponent],
})
export class PortfolioWidgetComponent {
	public widget: InputSignal<WidgetInterface<PortfolioSettingsInterface> | null> =
		input<WidgetInterface<PortfolioSettingsInterface> | null>(null)
}
